import { HttpResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as saveAs from 'file-saver';
import * as JSZip from 'jszip';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Subscription } from 'rxjs';
import { CustomerService } from 'src/app/services/customer.service';
import { FileService } from 'src/app/services/file.service';
import { RebateContractService } from 'src/app/services/rebate-contract.service';

@Component({
  selector: 'app-rebate',
  templateUrl: './rebate.component.html',
  styleUrls: ['./rebate.component.less']
})

export class RebateComponent implements OnInit {

  @Input() tabSelectedIndex: number | undefined;
  @Input() type: string | undefined;
  private customerSubscription: Subscription | undefined;
  loading = false;
  tabs = [
    { key: 'settled', label: 'DETAILS_CALCULATED_REBATE' },
    { key: 'released', label: 'DETAILS_PENDING_REBATE' },
    { key: 'used', label: 'DETAILS_USED_REBATE' }
  ] as const;

  activeTab: string = 'settled';
  settledList: any[] = [];
  releasedList: any[] = [];
  usedList: any[] = [];
  totalEstimatedRebateAmount = '';
  totalSettledRebateAmount = '';
  totalTotalAmount = '';
  totalRebateUsedAmount = '';
  isReleasedRebateDisplay = false;
  isUsedRebateDisplay = false;

  modalVisible = false;
  comment = '';
  selectedItem: any;
  showAction = false;
  latestUpdateTime: string = "2025-08-29 15:19:41";
  selectedYear = localStorage.getItem("selectedYear") ? localStorage.getItem("selectedYear") : '';
  yearList = [];
  firstLoading = false;

  paginationMap = {
    settled: { pageNum: 1, pageSize: 10, total: 0 },
    released: { pageNum: 1, pageSize: 10, total: 0 },
    used: { pageNum: 1, pageSize: 10, total: 0 },
  };

  constructor(private message: NzMessageService, private rebateContractService: RebateContractService, private translate: TranslateService,
    private fileService: FileService,
    private router: Router,
    private route: ActivatedRoute,
    private customerService: CustomerService,
  ) { }

  async ngOnInit(): Promise<void> {
    this.getYearList();
    this.route.queryParams.subscribe(params => {
      const tabSelectNumber = params['tabSelectNumber'];
      const type = params['type'];

      if (tabSelectNumber == 1) {
        this.activeTab = type;
      }
      this.loadData(type);
      this.firstLoading = false;
    });

    this.customerSubscription = this.customerService.selectedCustomer$.subscribe(async () => {
      if (this.tabSelectedIndex == 1 && !this.firstLoading) {
        this.resetPaginationMap()
        this.getYearList();
      }
    });
  }

  resetPaginationMap() {
    this.paginationMap = {
      settled: { pageNum: 1, pageSize: 10, total: 0 },
      released: { pageNum: 1, pageSize: 10, total: 0 },
      used: { pageNum: 1, pageSize: 10, total: 0 },
    };;
  }

  getYearList() {
    this.rebateContractService.getRebateYearList({ year: this.selectedYear }).subscribe(result => {
      const { rtnData } = result;
      this.yearList = rtnData.allYear;
      if(this.selectedYear === '') {
        this.selectedYear = this.yearList[0];
        localStorage.setItem("selectedYear", this.yearList[0]);
      }
      this.latestUpdateTime = rtnData.latestUpdateTime;
      this.loadData(this.activeTab as 'settled' | 'released' | 'used');
    });
  }

  export(format: 'excel' | 'pdf') {
    if (format === 'excel') {
    } else {
    }
  }

  ngOnDestroy(): void {
    if (this.customerSubscription) {
      this.customerSubscription.unsubscribe();
    }
  }

  switchTab(tab: 'settled' | 'released' | 'used') {
    this.activeTab = tab;
    this.loadData(tab);
  }

  handleChangeCurrentPage(pageNum: number, type: 'settled' | 'released' | 'used') {
    this.paginationMap[type].pageNum = pageNum;
    this.loadData(type);
  }

  handleChangepageSize(pageSize: number, type: 'settled' | 'released' | 'used') {
    this.paginationMap[type].pageSize = pageSize;
    this.paginationMap[type].pageNum = 1;
    this.loadData(type);
  }

  loadData(type: 'settled' | 'released' | 'used') {
    if(!type){
      return;
    }
    const page = this.paginationMap[type];
    if (type === 'settled') {
      this.rebateContractService.getSettledList({ pageNum: page.pageNum, pageSize: page.pageSize, year: this.selectedYear })
        .subscribe(res => {
          const { records, total } = res.rtnData;
          this.settledList = records;
          page.total = total;
        });
    }

    if (type === 'released') {
      this.rebateContractService.getReleasedList({ pageNum: page.pageNum, pageSize: page.pageSize, year: this.selectedYear })
        .subscribe(res => {
          const { records, total } = res.rtnData;
          this.releasedList = records;
          page.total = total;

          if (records.length > 0) {
            this.isReleasedRebateDisplay = true;
            const estimatedRebateAmountArray: any[] = [];
            const settledRebateAmountArray: any[] = [];
            const totalAmountArray: any[] = [];
            records.forEach((element: any) => {
              estimatedRebateAmountArray.push(element.estimatedRebateAmount);
              settledRebateAmountArray.push(element.settledRebateAmount);
              totalAmountArray.push(element.totalAmt);
            });
            this.totalEstimatedRebateAmount = this.sumStrings(estimatedRebateAmountArray);
            this.totalSettledRebateAmount = this.sumStrings(settledRebateAmountArray);
            this.totalTotalAmount = this.sumStrings(totalAmountArray);
          } else {
            this.isReleasedRebateDisplay = false;
            this.totalEstimatedRebateAmount = '';
            this.totalSettledRebateAmount = '';
            this.totalTotalAmount = '';
          }
        });
    }

    if (type === 'used') {
      this.rebateContractService.getUsedList({ pageNum: page.pageNum, pageSize: page.pageSize, year: this.selectedYear })
        .subscribe(res => {
          const { records, total } = res.rtnData;
          this.usedList = records;
          page.total = total;

          if (records.length > 0) {
            this.isUsedRebateDisplay = true;
            const rebateUsedAmountArray: any[] = [];
            records.forEach((element: any) => {
              rebateUsedAmountArray.push(element.expectedAmount);
            });
            this.totalRebateUsedAmount = this.sumStrings(rebateUsedAmountArray);
          } else {
            this.isUsedRebateDisplay = false;
            this.totalRebateUsedAmount= '';
          }
        });
    }
  }

  sumStrings(values: any[]): string {
    if (!Array.isArray(values) || values.length === 0) return '-';

    let validCount = 0; // 统计有效数字的数量
    const total = values.reduce((sum, val) => {
      if (val === null || val === undefined || val === '' || val === '-' || val === 'N/A') {
        return sum;
      }

      const num = parseFloat(val);
      if (isNaN(num)) return sum;
      validCount++;
      return sum + num;
    }, 0);

    if (validCount === 0) {
      return '-';
    }

    return total.toString();
  }

  onYearChange(year: string) {
    this.selectedYear = year;
    localStorage.setItem("selectedYear", year);
    this.resetPaginationMap()
    this.loadData(this.activeTab as 'settled' | 'released' | 'used');
  }


  onView(item: any) {
    window.open(item.rebateSettlementFile, '_blank')
  }

  onReview(item: any) {
    this.modalVisible = true;
    this.selectedItem = item;
  }

  async onDownload(id:any) : Promise<void> {
    await this.fileService
      .exportToExcel(
        `/dealer_portal/target-ach/rebate-detail/download?rebateSettlementId=${id}`
      ).subscribe(async (response: HttpResponse<Blob>) => {
        const contentDisposition = response.headers.get('Content-Disposition');
        let fileName = 'export.xlsx';
        if (contentDisposition) {
          const matches = /filename\*?=(?:UTF-8'')?"?([^"]+)"?/.exec(contentDisposition);
          if (matches && matches[1]) {
            fileName = decodeURIComponent(matches[1]);
          }
        }
        saveAs(response.body!, fileName);
      },
        (error: any) => {
          console.error('Error exporting Zip:', error);
        })
  }
  async onDownloadPDF(id:any): Promise<void>{
    await this.fileService
      .exportToExcel(
        `/dealer_portal/target-ach/download/pdf?rebateSettlementId=${id}`
      ).subscribe(async (response: HttpResponse<Blob>) => {
        const contentDisposition = response.headers.get('Content-Disposition');
        let fileName = 'export.xlsx';
        if (contentDisposition) {
          const matches = /filename\*?=(?:UTF-8'')?"?([^"]+)"?/.exec(contentDisposition);
          if (matches && matches[1]) {
            fileName = decodeURIComponent(matches[1]);
          }
        }
        saveAs(response.body!, fileName);
      },
        (error: any) => {
          console.error('Error exporting Zip:', error);
        })
  }

  getColorByStatus(status: string, isBackground: boolean, isBorder: boolean): string {
    let color = "";
    switch (status) {
      case "审批中":
        color = isBackground ? "#FEF5E9" : (isBorder ? "#F6C172" : "#F19F23");
        break;
      case "审批拒绝":
        color = isBackground ? "#F9F2F9" : (isBorder ? "#C279BE" : "#9E2896");
        break;
      case "审批通过":
        color = isBackground ? "#F1F8F7" : (isBorder ? "#84BDBA" : "#18837E");
        break;
      case "撤回":
        color = isBackground ? "#F2F3F4" : (isBorder ? "#B2B9C0" : "#A0A0A0");
        break;
      default:
        color = isBackground ? "#F2F3F4" : (isBorder ? "#B2B9C0" : "#A0A0A0");
        break;
    }
    return color;
  }

  formatMoney(value: any, decimals = 2): string {
    if (value === null || value === undefined || value === '' || value === 0) {
      return '-';
    }

    const num = Number(value);
    if (isNaN(num)) {
      return String(value);
    }

    return num
      .toFixed(decimals)
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  multiplyFormatted(value: any, factor = 1.13, decimals = 2) {
    const num = Number(String(value).replace(/,/g, ''));
    if (isNaN(num)) return '-';
    return this.formatMoney(num * factor, decimals);
  }

  handleOk(type: number) {
    // if (!this.comment.trim()) {
    //   this.message.create('warning', this.translate.instant('PLACEHOLDER_MESSAGE'));
    //   return;
    // }
    this.rebateContractService.syncStatus({ id: this.selectedItem.rebateSettlementId,action:type==0?'reject':'agree',comment:this.comment})
      .subscribe(res => {
        this.modalVisible = false;
        this.comment = '';
        this.loadData('settled');
      });

  }
  handleCancel() {
    this.modalVisible = false;
  }

}
